import { TableColumnsSetting } from '@/interfaces/table-setting';
import { CrossF8Model } from '@/models/imports/cross-f8-model';

export class CrossF8SettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<keyof CrossF8Model> {
    return [
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'practiceNumber',
        text: 'Num. pratica',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'acquisitionPropertyName',
        text: 'Nome cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'clAcquisitionPropertySurname',
        text: 'Cognome cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'modelDescription',
        text: 'Descrizione modello',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
